import { addSlidesTabIndex } from '@gravity-global/helpers/swiper/add-slides-tab-index';

const infoCardSliderInit = () => {
  const mainPattern = document.querySelectorAll('.gg-info-cards-dark');

  mainPattern.forEach((module) => {
    const swipers = module.querySelector('.gg-info-cards-dark_group-slider');
    const swiperWrapper = module.querySelector('.gg-info-cards-dark_lists-item');
    const swiperSlides = module.querySelectorAll('.wp-block-media-text');
    const numberOfSlides = swiperSlides.length;
    if (!swipers || !swiperWrapper) {
      return;
    }
    swiperSlides.forEach((slide, index) => {
      slide.classList.add('fade-in-up', `delay-${index}`);
    });

    const groupButton = module.querySelector('.gg-button-carousel__button-no-outline');
    if (swipers == null) {
      groupButton.classList.add('d-none');
    }
    if (!swipers || !swiperWrapper) {
      return;
    }

    if (numberOfSlides > 4) {
      const swiperNext = module.querySelector('.gg-button-carousel__button-no-outline__next-btn > a');
      const swiperPrev = module.querySelector('.gg-button-carousel__button-no-outline__prev-btn > a');

    if (swiperPrev) swiperPrev.setAttribute('rel', 'prev');
    if (swiperNext) swiperNext.setAttribute('rel', 'next');

      swipers.classList.add('swiper-container');
      swiperWrapper.classList.add('swiper-wrapper');
      swiperSlides.forEach((slide) => {
        slide.classList.add('swiper-slide');
      });

      const carousel = new window.Swiper(swipers, {
        loop: false,
        centeredSlides: false,
        watchOverflow: true,
        watchSlidesProgress: true,
        spaceBetween: 17,
        slidesPerGroup: 1,
        slidesPerView: 4,
        allowTouchMove: true,
        navigation: {
          prevEl: swiperPrev,
          nextEl: swiperNext,
        },
        breakpoints: {
          1200: {
            slidesPerView: 4,
          },
          1025: {
            slidesPerView: 2.1,
          },
          750: {
            slidesPerView: 2,
          },
          480: {
            slidesPerView: 1,
          },
          200: {
            slidesPerView: 1,
          },
        },
        on: {
          init: (swiper) => addSlidesTabIndex(swiper),
          slideChange: (swiper) => addSlidesTabIndex(swiper),
        },
      });
      setTimeout(() => {
        carousel.init();
      }, 300);
    } else {
      groupButton.classList.add('d-none');
    }
  });
};
infoCardSliderInit();
